export enum EModalName {
  AVATAR_UPLOAD = 'avatar_upload',
  CHAT = 'chat',
  CONFIRM_PLAYER_KICK = 'confirm_player_kick',
  CONFIRM_SUPPORT = 'confirm_support',
  CONFIRM_TABLE_DELETE = 'confirm_table_delete',
  HAND_HISTORY = 'hand_history',
  INFO_PLAYER_KICKED = 'info_player_kicked',
  INFO_TABLE_DELETE_SUCCESSFULLY = 'info_table_delete_successfully',
  INFO_TABLE_SETTINGS_CHANGED = 'info_table_settings_changed',
  INFO_TABLE_STATE_UPDATE_ERROR = 'info_table_state_update_error',
  CONFIRM_TRANSACTION_ERROR = 'confirm_transaction_error',
  LEADERBOARD = 'leaderboard',
  TABLE_SETTINGS = 'table_settings',
  TABLE_ADMIN_SETTINGS = 'table_admin_settings',
  TABLE_BUY_IN = 'table_buy_in',
  TABLE_DRAWER = 'table_drawer',
  TABLE_INFO_PAYMENT_PROCESSING = 'info_payment_processing',
  TABLE_INSUFFICIENT_BALANCE = 'insufficient_balance',
  TABLE_NOT_FOUND = 'table_not_found',
  TABLE_PASSWORD_REQUEST = 'table_password_request',
  TABLE_PLAYERS = 'table_players',
  TABLE_WAS_DELETED = 'table_was_deleted',
  TABLE_WITHDRAWAL = 'table_withdrawal',
  TABLE_WRONG_PASSWORD = 'table_wrong_password',
  TABLE_YOU_WAS_KICKED = 'table_you_was_kicked',
  TOO_MUCH_PRIVATE_TABLES = 'too_much_private_tables',
  POLL_DOUBLE_BOARD = 'POLL_DOUBLE_BOARD',
  NEW_TABLE_TAB = 'NEW_TABLE_TAB',
  UNCLAIMED_REWARDS = 'UNCLAIMED_REWARDS',
}
